/**
 * Converts a numeric alpha value to a string percentage.
 *
 * @param {number} [alpha=0] - The alpha value in the domain [0, 1]
 * @return {string} The percentage representation (e.g. '100%')
 */
export default function alphaToPercent(alpha = 0) {
  return Math.round(alpha * 100) + '%';
}
